'use client'

import { useDeviceType } from '@/hooks/use-device-type'
import type { VisibleOnProps } from './types'

export const VisibleOn = ({
  children,
  className,
  mobile,
  tablet,
  desktop,
}: VisibleOnProps) => {
  const deviceType = useDeviceType()

  const isVisible =
    (mobile && deviceType === 'mobile') ||
    (tablet && deviceType === 'tablet') ||
    (desktop && deviceType === 'desktop')

  if (!isVisible) return null

  if (className) return <div className={className}>{children}</div>

  return <>{children}</>
}
